import React from 'react';
import {BaseMixin, ElementaryMixin, NestingLevelMixin} from '../common/common.js';
import Environment from '../environment/environment.js';

import './backdrop.less';

export const Backdrop = React.createClass({
  //@@viewOn:mixins
  mixins: [
    BaseMixin,
    ElementaryMixin,
    NestingLevelMixin
  ],
  //@@viewOff:mixins

  //@@viewOn:statics
  statics: {
    tagName: 'UU5.Bricks.Backdrop',
    nestingLevelList: Environment.getNestingLevelList('bigBoxCollection', 'smallBox'),
    classNames: {
      main: 'uu5-bricks-backdrop'
    },
    opt: {
      nestingLevelWrapper: true
    }
  },
  //@@viewOff:statics

  //@@viewOn:propTypes
  propTypes: {
    onClick: React.PropTypes.func,
    onMouseOver: React.PropTypes.func
  },
  //@@viewOff:propTypes

  //@@viewOn:getDefaultProps
  getDefaultProps: function () {
    return {
      onClick: null,
      onMouseOver: null
    };
  },
  //@@viewOff:getDefaultProps

  //@@viewOn:interface
  //@@viewOff:interface

  //@@viewOn:overridingMethods
  //@@viewOff:overridingMethods

  //@@viewOn:componentSpecificHelpers
  //@@viewOff:componentSpecificHelpers

  //@@viewOn:render
  render: function () {
    var mainAttrs = this.buildMainAttrs();
    mainAttrs.id = this.getId();
    if (typeof this.props.onClick === 'function') {
      mainAttrs.onClick = (e) => this.props.onClick(this, e)
    }
    if (typeof this.props.onMouseOver === 'function') {
      mainAttrs.onMouseOver = (e) => this.props.onMouseOver(this, e)
    }

    return (
      this.getNestingLevel()
        ? (
          <div {...mainAttrs}>
            {this.getDisabledCover()}
          </div>
        ) : null
    );
  }
  //@@viewOff:render
});

export default Backdrop;



// WEBPACK FOOTER //
// ./bricks/backdrop.js